import React, { lazy, Suspense } from 'react'
import { Route } from 'react-router-dom'
import { capitalize, courseName } from '../components/common/utils'

const allCourses = Object.values(courseName).reduce((all, c) => {
  all[c + 'Sc'] = lazy(() => import(`../components/CourseInfo/${c}Sc`))
  all[c + 'Tc'] = lazy(() => import(`../components/CourseInfo/${c}Tc`))
  return all
}, {})
const CourseInfoRoutes = () => (
  <Suspense fallback={<div>Loading...</div>}>
    <Route
      path="/course/:course/:language"
      /* 这里必须用 render 而不是 component：component 收的是「组件类型」，
         传内联函数会让 react-router 每帧都当成新组件，导致子树反复卸载重挂（5.2+ 会为此告警） */
      render={({
        match: {
          params: { course, language },
        },
      }) => {
        const index = course + capitalize(language === 'tc' ? 'tc' : 'sc')
        const CourseInfo = allCourses[index]
        return <CourseInfo course={course} />
      }}
    />
  </Suspense>
)
export default CourseInfoRoutes
